'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $ct_Lmealorama_components_MuiComponents$InputType__T__($thiz, value) {
  $thiz.lm = value;
  return $thiz;
}
export { $ct_Lmealorama_components_MuiComponents$InputType__T__ as $ct_Lmealorama_components_MuiComponents$InputType__T__ };
/** @constructor */
function $c_Lmealorama_components_MuiComponents$InputType() {
  this.lm = null;
}
export { $c_Lmealorama_components_MuiComponents$InputType as $c_Lmealorama_components_MuiComponents$InputType };
$p = $c_Lmealorama_components_MuiComponents$InputType.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MuiComponents$InputType;
/** @constructor */
function $h_Lmealorama_components_MuiComponents$InputType() {
}
export { $h_Lmealorama_components_MuiComponents$InputType as $h_Lmealorama_components_MuiComponents$InputType };
$h_Lmealorama_components_MuiComponents$InputType.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=mealorama.components.-Mui-Components$-Input-Type.js.map
